/* global window */

import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { config } from "../config";

// components
import MySofologyLogo from "./graphics/MySofologyLogo";
import SofologistHeader from "./SofologistHeader";

// ACTIONS
import { logoutUser } from "../actions/user";

class SiteHeader extends Component {
  constructor(props) {
    super(props);
    this.handleLogout = this.handleLogout.bind(this);
  }

  handleLogout() {
    this.props.logoutUser();
    const logoutUrl = new URL(config.URLS.MY_SOFOLOGY_LOGIN);
    logoutUrl.searchParams.append("logged-out", "true");
    window.location.href = logoutUrl.toString();
  }

  render() {
    const hideLogout = this.props.isSofologist || this.props.hideLogout;
    return [
      <SofologistHeader key="site-header__sofologist" />,
      <header
        key="site-header__main"
        className="c-header u-black-bg u-padding-small"
      >
        <div className="u-margin-auto-center content">
          <a href={config.URLS.SOFOLOGY_HOME}>
            <MySofologyLogo />
          </a>

          {!hideLogout && (
            <button className="c-btn c-logout__btn" onClick={this.handleLogout}>
              Log out
            </button>
          )}
        </div>
      </header>,
    ];
  }
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      logoutUser,
    },
    dispatch
  );

const mapStateToProps = (state) => ({
  isSofologist: state.sofologist.Authorized,
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SiteHeader);



// WEBPACK FOOTER //
// ./src/layout/SiteHeader.js